export default __webpack_public_path__ + "static/media/msn-vdo.46e71f0c.png";